import { h } from "preact";

export function RentalSuggestionsTab({ rentalResults }) {
  return (
    <div className="tab-content h-full bg-brand-100 rounded-b-md">
      <div className="max-h-[300px] overflow-y-auto p-4">
        <ul className="flex flex-col gap-3">
          {rentalResults.map((result) => (
            <li key={result.id || result.url || result.name}>
              <a
                href={result.url}
                className="block bg-white rounded hover:shadow-sm transition p-2 grid grid-cols-[80px_1fr] gap-3 items-center"
              >
                <div className="w-20 h-20 flex items-center justify-center overflow-hidden rounded bg-brand-100">
                  {result.cover ? (
                    <img
                      src={result.cover}
                      alt=""
                      className="object-cover w-full h-full"
                    />
                  ) : null}
                </div>
                <div className="flex flex-col justify-center">
                  <span className="font-semibold text-brandcopy-900 leading-tight">
                    {result.name}
                  </span>
                  <span className="text-sm text-brandcopy-600">
                    {result.city} {result.zipcode}
                  </span>
                </div>
              </a>
            </li>
          ))}
        </ul>
        {rentalResults.length === 0 && (
          <span>
            {global.Translator.trans("locationform.noresults", {}, "js")}
          </span>
        )}
      </div>
    </div>
  );
}
